import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * read as regular text (the lines are just a decoration and not a semantic separator) */
  children: PropTypes.node
};
function HorizontalSeparator(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "horizontal-or-separator",
    role: children ? null : 'separator'
  }, children);
}
HorizontalSeparator.propTypes = propTypes;

export { HorizontalSeparator as default };
//# sourceMappingURL=HorizontalSeparator.js.map
